import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private snackBar: MatSnackBar) { }
  toast(
    message: string,
    type: ToastType,
    horizontalPosition: MatSnackBarHorizontalPosition = 'center',
    verticalPosition: MatSnackBarVerticalPosition = 'bottom'
  ) {
    this.snackBar.open(message, '', {
      // duration for toast  Message
      duration: 5000,
      horizontalPosition: horizontalPosition,
      verticalPosition: verticalPosition,
      //   if the type is error then it will take the styling of error
      //   else if type is warning it will take styling for
      //   warning and else take styling for information
      panelClass:
        type == ToastType.Error
          ? ['error_toast']
          : type == ToastType.Warning
            ? ['warning_toast']
            : ['information_toast'],
    });
  }
}

export enum ToastType {
  Warning = 'Warning',
  Error = 'Error',
  Information = 'information',
}
